import React from "react"
import { Accordion, Badge, Col, ListGroup, Row } from "react-bootstrap"
import withHooks from "./WithHooks"

class TodoGeneric extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.debug("const_props:", this.props)
  }

  render() {
    this.dMgr.rendering()

    let toRender = (
      <Row>
        <Col md={12}>
          <h3>TODO LIST</h3>

          <Row>
            <Col md={6}>
              <Accordion defaultActiveKey={["0"]} alwaysOpen data-bs-theme="dark">
                {this.props.high && (
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <Badge bg="danger">HIGH</Badge>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ListGroup data-bs-theme="dark">
                        {this.props.high.map((e, index) => {
                          return (
                            <ListGroup.Item variant="danger" key={index}>
                              {e}
                            </ListGroup.Item>
                          )
                        })}
                      </ListGroup>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </Accordion>
              <br />

              <Accordion defaultActiveKey={["1"]} alwaysOpen data-bs-theme="dark">
                {this.props.medium && (
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <Badge bg="warning" text="dark">
                        Medium
                      </Badge>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ListGroup data-bs-theme="dark">
                        {this.props.medium.map((e, index) => {
                          return (
                            <ListGroup.Item variant="warning" key={index}>
                              {e}
                            </ListGroup.Item>
                          )
                        })}
                      </ListGroup>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </Accordion>
              <br />
            </Col>
            <Col md={6}>
              <Accordion defaultActiveKey={["2"]} alwaysOpen data-bs-theme="dark">
                {this.props.question && (
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <Badge bg="info" text="dark">
                        Questions
                      </Badge>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ListGroup data-bs-theme="dark">
                        {this.props.question.map((e, index) => {
                          return (
                            <ListGroup.Item variant="info" key={index}>
                              {e}
                            </ListGroup.Item>
                          )
                        })}
                      </ListGroup>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </Accordion>
              <br />
              <Accordion data-bs-theme="dark">
                {this.props.low && (
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      <Badge bg="secondary" text="dark">
                        Low
                      </Badge>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ListGroup data-bs-theme="dark">
                        {this.props.low.map((e, index) => {
                          return (
                            <ListGroup.Item variant="secondary" key={index}>
                              {e}
                            </ListGroup.Item>
                          )
                        })}
                      </ListGroup>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </Accordion>
              <br />
              <Accordion data-bs-theme="dark">
                {this.props.done && (
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      <Badge bg="success" text="dark">
                        Done :)
                      </Badge>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ListGroup data-bs-theme="dark">
                        {this.props.done.map((e, index) => {
                          return (
                            <ListGroup.Item variant="success" key={index}>
                              {e}
                            </ListGroup.Item>
                          )
                        })}
                      </ListGroup>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </Accordion>
              <br />
            </Col>
          </Row>
        </Col>
      </Row>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(TodoGeneric)
